import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { VitalsService } from '../../vitals/services/vitals.service'
import { setApgarAppearanceOptions } from '../store/options.actions'

import { IOptionsResponse } from '../../../common/common.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getApgarAppearanceOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const vitalsService = new VitalsService(serviceId)
  try {
    const apgarAppearance: IOptionsResponse = yield call([vitalsService, vitalsService.getApgarAppearance])
    const { entity } = apgarAppearance
    yield put(setApgarAppearanceOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getApgarAppearanceOptions() error: ${e}`))
  }
}

export function* getApgarAppearanceOptionsSaga() {
  yield takeLatest(ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS, getApgarAppearanceOptions)
}
